export const RPM_ANALYSIS_REPORT_TYPE_FILTER = [
  {
    key: 0,
    value: 'caseManager',
    title: 'Case Manager'
  },
  {
    key: 1,
    value: 'facility',
    title: 'Facility'
  },
  {
    key: 2,
    value: 'group',
    title: 'Group'
  },
  {
    key: 3,
    value: 'careGiver',
    title: 'Caregiver'
  }
]

export const RPM_ANALYSIS_REPORT_COMPLIANCE_RULE_FILTER = [
  {
    key: 0,
    value: 'measurement',
    title: 'By measurement'
  },
  {
    key: 1,
    value: 'billing',
    title: 'By billing'
  }
]

export const RPM_ANALYSIS_REPORT_PERIOD_FILTER = [
  {
    key: 0,
    value: 'day',
    title: 'Day'
  },
  {
    key: 1,
    value: 'week',
    title: 'Week'
  },
  {
    key: 2,
    value: 'month',
    title: 'Month'
  },
  {
    key: 3,
    value: 'custom',
    title: 'Custom period'
  }
]
